import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react'
import HobnobModal from 'components/common/HobnobModal'

import styles from './image-search-modal.scss'
import PropTypes from 'prop-types'
import Button from 'src/components/common/Button'
import TextInputElement from 'components/forms/TextInputElement'
import SearchOutlinedIcon from 'src/assets/icons/ico-search-outlined.svg'
import SvgIcon from '../../../../components/common/SvgIcon'
import LoadingIndicator from 'src/components/common/LoadingIndicator'
import ImageItem from '../ImageItem/ImageItem'

import BabyIcon from 'src/assets/icons/ico-baby.svg'
import AdultBirthdayIcon from 'src/assets/icons/ico-adult-birthday.svg'
import BachelorPartyIcon from 'src/assets/icons/ico-bachelor-party.svg'
import BacheloretteIcon from 'src/assets/icons/ico-bachelorette.svg'
import BridalShowerIcon from 'src/assets/icons/ico-bridal-shower.svg'
import BusinessIcon from 'src/assets/icons/ico-business.svg'
import ChristmasIcon from 'src/assets/icons/ico-christmas.svg'
import CocktailPartyIcon from 'src/assets/icons/ico-cocktail-party.svg'
import CuratedByHobnobIcon from 'src/assets/icons/ico-curated-by-hobnob.svg'
import DinnerPartyIcon from 'src/assets/icons/ico-dinner-party.svg'
import EngagementIcon from 'src/assets/icons/ico-engagement.svg'
import FantasyIcon from 'src/assets/icons/ico-fantasy.svg'
import FathersDayIcon from 'src/assets/icons/ico-fathers-day.svg'
import GirlsNightOutIcon from 'src/assets/icons/ico-girls-night-out.svg'
import GraduationIcon from 'src/assets/icons/ico-graduation.svg'
import HalloweenIcon from 'src/assets/icons/ico-halloween.svg'
import KidsBirthdayIcon from 'src/assets/icons/ico-kids-birthday.svg'
import MothersDayIcon from 'src/assets/icons/ico-mothers-day.svg'
import NewYearsEveIcon from 'src/assets/icons/ico-new-years-eve.svg'
import SciFiIcon from 'src/assets/icons/ico-sci-fi.svg'
import SportsIcon from 'src/assets/icons/ico-sports.svg'
import SpringIcon from 'src/assets/icons/ico-spring.svg'
import SummerIcon from 'src/assets/icons/ico-summer.svg'
import ThanksgivingIcon from 'src/assets/icons/ico-thanksgiving.svg'
import EasterIcon from 'src/assets/icons/ico-easter.svg'
import ValentinesDayIcon from 'src/assets/icons/ico-valentines-day.svg'
import VibesIcon from 'src/assets/icons/ico-vibes.svg'
import WeddingIcon from 'src/assets/icons/ico-wedding.svg'
import AssortedIcon from 'src/assets/icons/ico-assorted.svg'
import SearchIcon from 'src/assets/icons/ico-search.svg'
import CloseIcon from 'assets/icons/close-icon-bg.png'
import imageJson from './image.json'
import { sortTabsByEventTitle } from './sortTabsByEventTitle'
import { message } from 'antd'
import ArrowLeftIcon from 'src/assets/icons/ico-arrow-left.svg'

const TABS = Object.keys(imageJson)

const TabItems = [
  {
    label: 'Baby',
    icon: BabyIcon,
    value: 'baby'
  },
  {
    label: 'Birthday',
    icon: AdultBirthdayIcon,
    value: 'birthday'
  },
  {
    label: 'Bachelor Party',
    icon: BachelorPartyIcon,
    value: 'bachelor'
  },
  {
    label: 'Bachelorette',
    icon: BacheloretteIcon,
    value: 'bachelorette'
  },
  {
    label: 'Bridal Shower',
    icon: BridalShowerIcon,
    value: 'bridal-shower'
  },
  {
    label: 'Business',
    icon: BusinessIcon,
    value: 'corporate'
  },
  {
    label: 'Christmas',
    icon: ChristmasIcon,
    value: 'christmas'
  },
  {
    label: 'Cocktail Party',
    icon: CocktailPartyIcon,
    value: 'cocktailparty'
  },
  {
    label: 'Hobnob Curated',
    icon: CuratedByHobnobIcon,
    value: 'curatedbyhobnob'
  },
  {
    label: 'Dinner Party',
    icon: DinnerPartyIcon,
    value: 'dinnerparty'
  },
  {
    label: 'Engagement',
    icon: EngagementIcon,
    value: 'engagement'
  },
  {
    label: 'Fantasy',
    icon: FantasyIcon,
    value: 'fantasy'
  },
  {
    label: "Father's Day",
    icon: FathersDayIcon,
    value: 'fathersday'
  },
  {
    label: 'Girls Night Out',
    icon: GirlsNightOutIcon,
    value: 'girlsnight'
  },
  {
    label: 'Graduation',
    icon: GraduationIcon,
    value: 'graduation'
  },
  {
    label: 'Halloween',
    icon: HalloweenIcon,
    value: 'halloween'
  },
  {
    label: 'Kids Party',
    icon: KidsBirthdayIcon,
    value: 'kidsparty'
  },
  {
    label: "Mother's Day",
    icon: MothersDayIcon,
    value: 'mothersday'
  },
  {
    label: 'New Year Eve',
    icon: NewYearsEveIcon,
    value: 'newyearseve'
  },
  {
    label: 'Sci-Fi',
    icon: SciFiIcon,
    value: 'scifi'
  },
  {
    label: 'Sports',
    icon: SportsIcon,
    value: 'sports'
  },
  {
    label: 'Spring',
    icon: SpringIcon,
    value: 'spring'
  },
  {
    label: 'Summer',
    icon: SummerIcon,
    value: 'summer'
  },
  {
    label: 'Thanksgiving',
    icon: ThanksgivingIcon,
    value: 'thanksgiving'
  },
  {
    label: 'Easter',
    icon: EasterIcon,
    value: 'easter'
  },
  {
    label: "Valentine's Day",
    icon: ValentinesDayIcon,
    value: 'valentines'
  },
  {
    label: 'Vibes',
    icon: VibesIcon,
    value: 'vibes'
  },
  {
    label: 'Wedding',
    icon: WeddingIcon,
    value: 'wedding'
  },
  {
    label: 'Assorted',
    icon: AssortedIcon,
    value: 'assorted'
  },
  {
    label: 'Generic',
    icon: AssortedIcon,
    value: 'generic'
  }
]

const SEARCH_TAB = {
  label: 'Search',
  icon: SearchIcon,
  value: 'search'
}

const PAGE_SIZE = 20
const DEBOUNCE_DELAY = 500
const SEARCH_PER_PAGE = 60

const ImageSearchModal = (props) => {
  const { show, eventName, handleCancel, buttonDisabled, handleImageSearchSave } = props
  const [selectedUrl, setSelectedUrl] = React.useState('')
  const [searchValue, setSearchValue] = React.useState('')

  const sortedTabs = sortTabsByEventTitle(eventName, TABS)
  const allTabs = useMemo(() => [SEARCH_TAB.value, ...sortedTabs], [sortedTabs])
  const allTabItems = useMemo(() => [SEARCH_TAB, ...TabItems], [])

  const [activeTab, setActiveTab] = useState(allTabs[1])
  const [searchImages, setSearchImages] = useState([])
  const [page, setPage] = useState(1)
  const [searchPage, setSearchPage] = useState(1)
  const imageViewRef = useRef(null)
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('')
  const debounceTimer = useRef(null)
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [searchMeta, setSearchMeta] = useState({
    hasMore: true,
    totalResults: 0,
    currentPage: 0
  })
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const tabContainerRef = useRef(null)
  const SCROLL_OFFSET = 500

  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  useEffect(() => {
    const checkScroll = () => {
      const el = tabContainerRef.current
      if (!el) return
      setCanScrollLeft(el.scrollLeft > 0)
      setCanScrollRight(el.scrollLeft + el.offsetWidth < el.scrollWidth)
    }
    checkScroll()
    if (tabContainerRef.current) {
      tabContainerRef.current.addEventListener('scroll', checkScroll)
    }
    return () => {
      if (tabContainerRef.current) {
        tabContainerRef.current.removeEventListener('scroll', checkScroll)
      }
    }
  }, [allTabs.length])

  const handleScrollLeft = () => {
    if (tabContainerRef.current) {
      tabContainerRef.current.scrollLeft -= SCROLL_OFFSET
    }
  }
  const handleScrollRight = () => {
    if (tabContainerRef.current) {
      tabContainerRef.current.scrollLeft += SCROLL_OFFSET
    }
  }

  useEffect(() => {
    setPage(1)
    setSearchPage(1)
    scrollToTop()
  }, [activeTab])

  useEffect(() => {
    const handleScroll = () => {
      const el = imageViewRef.current
      if (!el) return
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 50) {
        if (activeTab === 'search') {
          if (searchMeta.hasMore && !isLoadingMore && !isSearchLoading) {
            setSearchPage(p => p + 1)
          }
        } else {
          const images = imageJson[activeTab] || []
          if (page * PAGE_SIZE < images.length) {
            setPage(p => p + 1)
          }
        }
      }
    }
    const el = imageViewRef.current
    if (el) {
      el.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll)
      }
    }
  }, [activeTab, page, searchPage, searchMeta.hasMore, isLoadingMore, isSearchLoading])

  const scrollToTop = useCallback(() => {
    if (imageViewRef.current) {
      imageViewRef.current.scrollTop = 0
    }
  }, [])

  const handleInputChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
    setSearchPage(1)
    setSearchMeta({ hasMore: true, totalResults: 0, currentPage: 0 })

    if (value.trim()) {
      setSearchImages([])
      scrollToTop()
    }

    if (debounceTimer.current) clearTimeout(debounceTimer.current)
    debounceTimer.current = setTimeout(() => {
      setDebouncedSearchValue(value)
    }, DEBOUNCE_DELAY)
  }

  const handleClearInputChange = () => {
    setSearchValue('')
    setDebouncedSearchValue('')
    setSearchPage(1)
    setSearchMeta({ hasMore: true, totalResults: 0, currentPage: 0 })
    setSearchImages([])
    scrollToTop()
    if (debounceTimer.current) clearTimeout(debounceTimer.current)
  }

  useEffect(() => {
    if (activeTab === 'search' && debouncedSearchValue.trim()) {
      if (searchPage === 1) {
        setIsSearchLoading(true)
        setSearchImages([])
        scrollToTop()
      } else {
        setIsLoadingMore(true)
      }

      const query = encodeURIComponent(debouncedSearchValue)
      const url = `https://api.pexels.com/v1/search?query=${query}&per_page=${SEARCH_PER_PAGE}&size=medium&page=${searchPage}`
      fetch(url, {
        headers: {
          Authorization: '563492ad6f91700001000001b478983a1a644cc5880756858a4ef689'
        }
      })
        .then(res => res.json())
        .then(data => {
          const newPhotos = data.photos?.map(photo => photo.src.medium) || []
          if (searchPage === 1) {
            setSearchImages(newPhotos)
          } else {
            setSearchImages(prev => [...prev, ...newPhotos])
          }
          setSearchMeta({
            hasMore: !!data.next_page,
            totalResults: data.total_results || 0,
            currentPage: data.page || searchPage
          })
        })
        .catch((error) => {
          message.error('Something went wrong. Please try again later. the error is: ' + error.message)
          setSearchMeta(prev => ({ ...prev, hasMore: false }))
        })
        .finally(() => {
          setIsSearchLoading(false)
          setIsLoadingMore(false)
        })
    } else if (activeTab === 'search' && !debouncedSearchValue.trim()) {
      setSearchImages([])
    }
  }, [debouncedSearchValue, activeTab, searchPage])

  const images = imageJson[activeTab] || []
  const pagedImages = useMemo(() => images.slice(0, page * PAGE_SIZE), [images, page])

  const handleSelect = useCallback((url) => {
    setSelectedUrl(prev => prev === url ? '' : url)
  }, [])

  const onClickSave = () => {
    if (selectedUrl) {
      handleImageSearchSave(selectedUrl)
      setSelectedUrl('')
    }
  }

  const onSearchInputBlur = () => {
    setActiveTab('search')
  }

  const renderTabs = () => {
    return allTabs.map(tab => (
      <div
        key={tab}
        className={`${styles['tab-item']} ${activeTab === tab ? styles['tab-item-active'] : ''} ${tab === 'search' ? styles['tab-item-search'] : ''}`}
        onClick={() => setActiveTab(tab)}
        role="tab"
        tabIndex={0}
        aria-selected={activeTab === tab}
        onKeyDown={(e) => e.key === 'Enter' && setActiveTab(tab)}
      >
        {
          allTabItems.find(item => item.value === tab) && (
            <>
              <SvgIcon
                divClassName={styles['tab-icon']}
                color={activeTab === tab ? '#303030' : '#7A7A7A'}
                icon={allTabItems.find(item => item.value === tab).icon}
              />
              <div className={styles['tab-label']}>{allTabItems.find(item => item.value === tab).label}</div>
            </>
          )
        }
      </div>
    ))
  }

  return (
    <HobnobModal
      containerClassName={styles['image-search-modal-container']}
      show={show}
      onClose={handleCancel}
      containerStyles={{ width: 'auto', maxWidth: 'none', padding: 0 }}
      cancelButtonClassName={styles['image-search-modal-cancel-button']}
    >
      <div className={styles['image-search-modal']}>
        <header className={styles['image-search-modal-header']}>
          <section className={styles['input-wrapper-section']}>
            <div className={styles['input-wrapper']}>
              <SvgIcon icon={SearchOutlinedIcon} divClassName={styles['search-icon']} />

              <TextInputElement
                className={styles['input-inner']}
                placeholder="Search"
                onFocus={onSearchInputBlur}
                onChange={handleInputChange}
                valid
                value={searchValue}
                maxLength={50}
              />
              {searchValue && <img src={CloseIcon} width="18" onClick={handleClearInputChange} />}
            </div>
          </section>
          <div className={styles['modal-title']}>Image Search</div>
        </header>
        {
          activeTab === 'search' && (
            <section className={styles['input-wrapper-mobile-section']}>
              <div className={styles['input-wrapper']}>
                <SvgIcon icon={SearchOutlinedIcon} divClassName={styles['search-icon']} />
                <TextInputElement
                  className={styles['input-inner']}
                  placeholder="Search"
                  onFocus={onSearchInputBlur}
                  onChange={handleInputChange}
                  valid
                  value={searchValue}
                  maxLength={50}
                />
                {searchValue && <img src={CloseIcon} width="18" onClick={handleClearInputChange} />}
              </div>
            </section>
          )
        }
        <div className={styles['tab-container']}>
          {canScrollLeft && (
            <div
              className={styles['arrow-left-wrapper']}
              onClick={handleScrollLeft}
            >
              <SvgIcon icon={ArrowLeftIcon} className={styles['arrow-left-icon']} />
            </div>
          )}
          <div className={styles['tab-items']} ref={tabContainerRef}>

            {renderTabs()}
          </div>
          {canScrollRight && (
            <div
              className={styles['arrow-right-wrapper']}
              onClick={handleScrollRight}
            >
              <SvgIcon icon={ArrowLeftIcon} className={styles['arrow-right-icon']} />
            </div>
          )}
        </div>
        <div className={styles['image-search-container']} ref={imageViewRef}>
          {
            isSearchLoading && searchPage === 1 && (
              <div className={styles['image-search-loading-container']}>
                <LoadingIndicator />
              </div>
            )
          }
          <div className={styles['image-view']}>
            <div className={styles['image-wrapper']}>
              {
                activeTab === 'search' ? (
                  searchImages.map((url, idx) => (
                    <ImageItem
                      key={`${url}-${idx}`}
                      url={url}
                      checked={selectedUrl === url}
                      alt={`search-${idx}`}
                      onClick={() => handleSelect(url)}
                    />
                  ))
                ) : (
                  pagedImages.map((filename, idx) => {
                    const url = `${process.env.S3_BASE_URL}/search_fliers/${filename}`
                    const checked = selectedUrl === url
                    return (
                      <ImageItem
                        key={url}
                        url={url}
                        checked={checked}
                        alt={activeTab + '-' + idx}
                        onClick={() => handleSelect(url)}
                      />
                    )
                  })
                )
              }
            </div>
          </div>

          {activeTab === 'search' && isLoadingMore && (
            <div className={styles['load-more-container']}>
              <LoadingIndicator />
            </div>
          )}
        </div>

        <div className={styles['actions']}>
          <Button disabled={buttonDisabled} filled={false} onClick={handleCancel}>
            <span>Cancel</span>
          </Button>
          <Button disabled={buttonDisabled || !selectedUrl} onClick={onClickSave}>
            <span>Save</span>
          </Button>
        </div>
      </div>
    </HobnobModal>
  )
}

ImageSearchModal.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleImageSearchSave: PropTypes.func,
  buttonDisabled: PropTypes.bool,
  eventName: PropTypes.string
}

export default ImageSearchModal
